var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-hover", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ hover }) {
          return _c(
            "div",
            { staticClass: "mx-2 mb-3", class: [hover ? "elevation-5" : ""] },
            [
              _c(
                "v-card",
                {
                  class: { "grey--text text--lighten-2": !hover },
                  attrs: { dark: "" },
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "py-0 px-0 font-weight-regular" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", "open-delay": 300 },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass: "unselectable mr-0",
                                        attrs: {
                                          color: _vm.eventType.color,
                                          label: "",
                                          small: "",
                                        },
                                      },
                                      [
                                        _c("v-icon", _vm._g({}, on), [
                                          _vm._v(_vm._s(_vm.eventType.icon)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.eventType.text) },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-chip",
                        {
                          staticClass: "unselectable ml-0",
                          attrs: {
                            color: _vm.eventType.eventColor,
                            label: "",
                            small: "",
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.eventType.title))]),
                          _vm._v(" "),
                          _c("v-icon", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(_vm.eventType.eventIcon)),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-chip",
                        {
                          staticClass: "d-flex align-center unselectable",
                          attrs: { label: "", small: "" },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("event"),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.format(_vm.item.resultDate)) +
                              " " +
                              _vm._s(_vm.timezoneId) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", "open-delay": 300 },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-chip",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "mx-1 d-flex align-center unselectable",
                                          attrs: { label: "", small: "" },
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", { staticClass: "mr-1" }, [
                                          _vm._v("folder_special"),
                                        ]),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.prettyPrintServiceName(
                                                _vm.item.serviceName
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.prettyPrintServiceName(
                                    _vm.item.serviceName
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" file type. "),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("ExecutionFileVersionChip", {
                        attrs: {
                          small: "",
                          fileVersions: _vm.item.relatedFileVersions,
                          isLatestVersion: _vm.item.isLatestVersion,
                        },
                        on: {
                          "click:version": function ($event) {
                            return _vm.goToFilterVersion($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "card-bg-2" },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "elevation-0 py-0 px-0 card-bg-1" },
                    [
                      _vm.item.isTestRun
                        ? _c("TestRun", {
                            attrs: {
                              "is-root": "",
                              hover: hover,
                              item: _vm.item,
                            },
                          })
                        : _vm.item.isRollback
                        ? _c("RollbackRun", {
                            attrs: {
                              "is-root": "",
                              hover: hover,
                              item: _vm.item,
                            },
                          })
                        : _c("DefaultRun", {
                            attrs: {
                              hover: hover,
                              "is-root": "",
                              item: _vm.item,
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  (_vm.item.isSuccess &&
                    _vm.item.importId &&
                    !(
                      _vm.item.isTestRun ||
                      _vm.item.isRollback ||
                      _vm.item.isRolledBack
                    )) ||
                  (_vm.item.executionId &&
                    (_vm.item.isIngestion || _vm.item.isTestRun))
                    ? [
                        _c("v-divider"),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _vm.item.isSuccess &&
                            _vm.item.importId &&
                            !(
                              _vm.item.isTestRun ||
                              _vm.item.isRollback ||
                              _vm.item.isRolledBack
                            )
                              ? [
                                  _vm.item.serviceLink !=
                                  "ecosurvey_edd_ingestion"
                                    ? _c(
                                        "SecondaryBtn",
                                        {
                                          attrs: {
                                            icon: "storage",
                                            small: "",
                                            to: {
                                              name: "import",
                                              params: {
                                                importId: _vm.item.importId,
                                              },
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              View import details\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.item.executionId != null &&
                                  _vm.item.isIngestion &&
                                  _vm.item.serviceLink !=
                                    "ecosurvey_edd_ingestion"
                                    ? _c("v-divider", {
                                        staticClass: "mx-2",
                                        attrs: { vertical: "" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isSystemAdmin || _vm.isTenantAdmin
                                    ? _c("RollbackImportAction", {
                                        attrs: { importId: _vm.item.importId },
                                      })
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.executionId
                              ? [
                                  _vm.item.isIngestion || _vm.item.isTestRun
                                    ? _c("v-divider", {
                                        staticClass: "mx-2",
                                        attrs: { vertical: "" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.item.isIngestion || _vm.item.isTestRun
                                    ? _c(
                                        "SecondaryBtn",
                                        {
                                          attrs: {
                                            small: "",
                                            icon: "pending_actions",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.reviewFile(_vm.item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Review file\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }